import { Leaf } from "lucide-react";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-[calc(100vh-72px)] grid lg:grid-cols-2">
    <div className="hidden lg:block relative">
      <img src="https://static.prod-images.emergentagent.com/jobs/0b8529c7-db2f-4cc8-ac82-6f8c699f5710/images/5d51e9894fe975205388138f425cfa29646a1e4b0aa929f265d9799e1567be3a.jpeg"
        alt="Calm mountains" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#2C4A3E]/45" />
      <div className="absolute bottom-12 left-12 right-12 text-[#FDFBF7]">
        <Leaf className="w-8 h-8" />
        <p className="font-display text-3xl mt-4 leading-snug">"The mind is not a vessel to be filled, but a fire to be kindled."</p>
        <p className="mt-2 text-sm opacity-80">Plutarch</p>
      </div>
    </div>
    <div className="flex items-center justify-center px-6 py-14">
      <div className="w-full max-w-md rise">
        <h1 className="font-display text-4xl text-[#2C4A3E]">{title}</h1>
        <p className="text-stone-500 mt-2">{subtitle}</p>
        <div className="mt-8">{children}</div>
      </div>
    </div>
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-xs font-semibold uppercase tracking-widest text-stone-500">{label}</span>
    <div className="mt-2">{children}</div>
  </label>
);

export const inputCls = "w-full px-5 py-3 rounded-2xl bg-white/70 border border-[#E6DEC3] focus:outline-none focus:border-[#2C4A3E]";
export const primaryBtn = "w-full py-3 rounded-full bg-[#2C4A3E] text-white font-medium hover:bg-[#1E352B] disabled:opacity-60 transition-colors";
